{
    "version": "0.1.0",
    "name": "presale_contract",
    "instructions": [
        {
            "name": "initialize",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "stateInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "paymentWalletUsdtAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "usdtMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "paymentWalletUsdcAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "usdcMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "paymentWallet",
                    "isMut": false,
                    "isSigner": false,
                    "docs": [
                        "CHECK"
                    ]
                },
                {
                    "name": "authority",
                    "isMut": true,
                    "isSigner": true,
                    "docs": [
                        "CHECK"
                    ]
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "owner",
                    "type": "publicKey"
                },
                {
                    "name": "admin",
                    "type": "publicKey"
                },
                {
                    "name": "startTime",
                    "type": "i64"
                },
                {
                    "name": "endTime",
                    "type": "i64"
                },
                {
                    "name": "claimStartTime",
                    "type": "i64"
                },
                {
                    "name": "maxTokensToSell",
                    "type": "u64"
                },
                {
                    "name": "tierThresholds",
                    "type": {
                        "vec": "u64"
                    }
                },
                {
                    "name": "tierPrices",
                    "type": {
                        "vec": "u64"
                    }
                },
                {
                    "name": "tierEndTimes",
                    "type": {
                        "vec": "i64"
                    }
                },
                {
                    "name": "currentTier",
                    "type": "u8"
                },
                {
                    "name": "timeConstant",
                    "type": "i64"
                }
            ]
        },
        {
            "name": "setPause",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "stateInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "signer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "pause",
                    "type": "bool"
                }
            ]
        },
        {
            "name": "setOwner",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "signer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "owner",
                    "type": "publicKey"
                }
            ]
        },
        {
            "name": "setAdmin",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "signer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "admin",
                    "type": "publicKey"
                }
            ]
        },
        {
            "name": "setClaimTime",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "stateInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "signer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "claimStartTime",
                    "type": "i64"
                }
            ]
        },
        {
            "name": "buyToken",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "stateInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "otherAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "signer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "paymentWallet",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "chainlinkFeed",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "chainlinkProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "tokenAmount",
                    "type": "u64"
                }
            ]
        },
        {
            "name": "buyWithUsdt",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "stateInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "signer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "paymentWalletUsdtAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "otherAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userUsdtAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "tokenAmount",
                    "type": "u64"
                }
            ]
        },
        {
            "name": "buyWithUsdc",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "stateInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "signer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "paymentWalletUsdcAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "otherAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userUsdcAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "tokenAmount",
                    "type": "u64"
                }
            ]
        },
        {
            "name": "buyTokenWert",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "stateInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "otherAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "signer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "user",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "paymentWallet",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "chainlinkFeed",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "chainlinkProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "tokenAmount",
                    "type": "u64"
                },
                {
                    "name": "solInLamports",
                    "type": "u64"
                }
            ]
        },
        {
            "name": "fundPresale",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "stateInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "presaleTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "authority",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "authorityTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "associatedTokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "amount",
                    "type": "u64"
                },
                {
                    "name": "tokenDecimals",
                    "type": "u8"
                }
            ]
        },
        {
            "name": "claimTokens",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "stateInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "userInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "signer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "userTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "presaleTokenAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "tokenMint",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "associatedTokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "tokenProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "modifyWhitelist",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "signer",
                    "isMut": true,
                    "isSigner": true
                }
            ],
            "args": [
                {
                    "name": "user",
                    "type": "publicKey"
                },
                {
                    "name": "add",
                    "type": "bool"
                }
            ]
        },
        {
            "name": "incrementCurrentRound",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "stateInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "signer",
                    "isMut": true,
                    "isSigner": true
                }
            ],
            "args": []
        },
        {
            "name": "setThresholds",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "stateInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "signer",
                    "isMut": true,
                    "isSigner": true
                }
            ],
            "args": [
                {
                    "name": "tierOriginalThresholds",
                    "type": {
                        "vec": "u64"
                    }
                }
            ]
        },
        {
            "name": "setTierThresholds",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "stateInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "signer",
                    "isMut": true,
                    "isSigner": true
                }
            ],
            "args": [
                {
                    "name": "tierThresholds",
                    "type": {
                        "vec": "u64"
                    }
                }
            ]
        },
        {
            "name": "setInitThresholds",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "stateInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "signer",
                    "isMut": true,
                    "isSigner": true
                }
            ],
            "args": [
                {
                    "name": "tierOriginalThresholds",
                    "type": {
                        "vec": "u64"
                    }
                }
            ]
        },
        {
            "name": "setPrices",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "stateInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "signer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "tierPrices",
                    "type": {
                        "vec": "u64"
                    }
                }
            ]
        },
        {
            "name": "setPricesAdmin",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "stateInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "signer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "tierPrices",
                    "type": {
                        "vec": "u64"
                    }
                }
            ]
        },
        {
            "name": "setTokenPrice",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "stateInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "signer",
                    "isMut": true,
                    "isSigner": true
                }
            ],
            "args": [
                {
                    "name": "price",
                    "type": "u64"
                }
            ]
        },
        {
            "name": "setAddPrices",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "stateInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "signer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "tierPrices",
                    "type": {
                        "vec": "u64"
                    }
                }
            ]
        },
        {
            "name": "setEndTimes",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "stateInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "signer",
                    "isMut": true,
                    "isSigner": true
                }
            ],
            "args": [
                {
                    "name": "tierEndTimes",
                    "type": {
                        "vec": "i64"
                    }
                }
            ]
        },
        {
            "name": "setRoundsInfo",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "stateInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "signer",
                    "isMut": true,
                    "isSigner": true
                }
            ],
            "args": [
                {
                    "name": "tokensLeftUnsold",
                    "type": {
                        "vec": "u64"
                    }
                },
                {
                    "name": "currentTier",
                    "type": "u8"
                },
                {
                    "name": "tokensSold",
                    "type": "u64"
                }
            ]
        },
        {
            "name": "setTokensLeftUnsold",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "stateInfo",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "signer",
                    "isMut": true,
                    "isSigner": true
                }
            ],
            "args": [
                {
                    "name": "tokensLeftUnsold",
                    "type": {
                        "vec": "u64"
                    }
                }
            ]
        },
        {
            "name": "setPaymentWallet",
            "accounts": [
                {
                    "name": "presaleAccount",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "signer",
                    "isMut": true,
                    "isSigner": true
                }
            ],
            "args": [
                {
                    "name": "paymentWallet",
                    "type": "publicKey"
                },
                {
                    "name": "paymentWalletNewUsdtAccount",
                    "type": "publicKey"
                }
            ]
        }
    ],
    "accounts": [
        {
            "name": "PresaleAccount",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "owner",
                        "type": "publicKey"
                    },
                    {
                        "name": "admin",
                        "type": "publicKey"
                    },
                    {
                        "name": "paymentWallet",
                        "type": "publicKey"
                    },
                    {
                        "name": "paymentWalletUsdtAccount",
                        "type": "publicKey"
                    },
                    {
                        "name": "paymentWalletUsdcAccount",
                        "type": "publicKey"
                    },
                    {
                        "name": "bump",
                        "type": "u8"
                    },
                    {
                        "name": "whitelist",
                        "type": {
                            "vec": "publicKey"
                        }
                    }
                ]
            }
        },
        {
            "name": "StateInfo",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "pause",
                        "type": "bool"
                    },
                    {
                        "name": "totalUsdRaised",
                        "type": "u64"
                    },
                    {
                        "name": "tokensSold",
                        "type": "u64"
                    },
                    {
                        "name": "tokenPrice",
                        "type": "u64"
                    },
                    {
                        "name": "tokensClaimed",
                        "type": "u64"
                    },
                    {
                        "name": "tokenStock",
                        "type": "u64"
                    },
                    {
                        "name": "startTime",
                        "type": "i64"
                    },
                    {
                        "name": "endTime",
                        "type": "i64"
                    },
                    {
                        "name": "claimStartTime",
                        "type": "i64"
                    },
                    {
                        "name": "maxTokensToSell",
                        "type": "u64"
                    },
                    {
                        "name": "tierOriginalThresholds",
                        "type": {
                            "vec": "u64"
                        }
                    },
                    {
                        "name": "tierThresholds",
                        "type": {
                            "vec": "u64"
                        }
                    },
                    {
                        "name": "tierPrices",
                        "type": {
                            "vec": "u64"
                        }
                    },
                    {
                        "name": "tierEndTimes",
                        "type": {
                            "vec": "i64"
                        }
                    },
                    {
                        "name": "tokensLeftUnsold",
                        "type": {
                            "vec": "u64"
                        }
                    },
                    {
                        "name": "currentTier",
                        "type": "u8"
                    },
                    {
                        "name": "timeConstant",
                        "type": "i64"
                    },
                    {
                        "name": "tokenConstant",
                        "type": "u64"
                    },
                    {
                        "name": "tokenDecimals",
                        "type": "u8"
                    },
                    {
                        "name": "presaleEnded",
                        "type": "bool"
                    }
                ]
            }
        },
        {
            "name": "UserInfo",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "id",
                        "type": "publicKey"
                    },
                    {
                        "name": "value",
                        "type": "u64"
                    }
                ]
            }
        }
    ],
    "events": [
        {
            "name": "TokensBought",
            "fields": [
                {
                    "name": "userAddress",
                    "type": "publicKey",
                    "index": false
                },
                {
                    "name": "tokensBought",
                    "type": "u64",
                    "index": false
                },
                {
                    "name": "purchaseToken",
                    "type": "string",
                    "index": false
                },
                {
                    "name": "amountPaid",
                    "type": "u64",
                    "index": false
                },
                {
                    "name": "usdEq",
                    "type": "u64",
                    "index": false
                },
                {
                    "name": "timestamp",
                    "type": "u64",
                    "index": false
                }
            ]
        },
        {
            "name": "TokensClaimed",
            "fields": [
                {
                    "name": "userAddress",
                    "type": "publicKey",
                    "index": false
                },
                {
                    "name": "tokensClaimed",
                    "type": "u64",
                    "index": false
                },
                {
                    "name": "timestamp",
                    "type": "u64",
                    "index": false
                }
            ]
        }
    ],
    "errors": [
        {
            "code": 6000,
            "name": "Unauthorized",
            "msg": "You are not authorized to perform this action."
        },
        {
            "code": 6001,
            "name": "InvalidAmount",
            "msg": "Amount should be greater than zero"
        },
        {
            "code": 6002,
            "name": "InvalidPaymentAccount",
            "msg": "Payment Wallet Address is not equal to Payment Wallet Address in presale_account"
        },
        {
            "code": 6003,
            "name": "ContractPause",
            "msg": "Contract is paused"
        },
        {
            "code": 6004,
            "name": "CalculationError",
            "msg": "Invalid Calculation Error"
        },
        {
            "code": 6005,
            "name": "InvalidPriceFeed",
            "msg": "Invalid Feed Address"
        },
        {
            "code": 6006,
            "name": "InvalidTime",
            "msg": "Invalid Time to buy"
        },
        {
            "code": 6007,
            "name": "TierUpdateFailed",
            "msg": "Unable to update tier, possibly already at the last tier or outside of presale period"
        },
        {
            "code": 6008,
            "name": "PresaleCompleted",
            "msg": "Presale has ended. No more token purchases allowed"
        },
        {
            "code": 6009,
            "name": "MaxTokenLimit",
            "msg": "token amount exceeds max tokens to buy in one transaction"
        },
        {
            "code": 6010,
            "name": "InvalidTokenProgram",
            "msg": "Invalid token program address."
        },
        {
            "code": 6011,
            "name": "InvalidWertSigner",
            "msg": "Invalid wert signer address."
        },
        {
            "code": 6012,
            "name": "InvalidTimestamps",
            "msg": "Invalid start and end Timestamps"
        },
        {
            "code": 6013,
            "name": "TokenDecimalError",
            "msg": "Token Decimals not set"
        },
        {
            "code": 6014,
            "name": "InvalidPythAddress",
            "msg": "Invalid pyth address"
        },
        {
            "code": 6015,
            "name": "InvalidToken",
            "msg": "Invalid Token Address"
        }
    ],
    "metadata": {
        "address": "Ej3MfTR62qW8dPwK1eBQ7Q5Ti23YVnDkYiYMgpWRgbv9"
    }
}
